import * as React from "react";
import { cn } from "~/lib/utils";

interface SectionTitleProps extends React.HTMLAttributes<HTMLHeadingElement> {
  as?: "h1" | "h2";
}

// Figma's Title/Sm (24px) -> Title/Md (32px) -> Title/XL (48px) scale, shared by every
// section headline that uses it. Line-height holds at 1.15 through Sm and Md, then
// tightens to 1.1 only at XL (lg+) — Figma's own per-tier value, not a px breakpoint.
export function SectionTitle({ as: Tag = "h2", className, ...props }: SectionTitleProps) {
  return (
    <Tag
      className={cn(
        "font-display text-figma-titles-sm-size leading-[1.15] font-extrabold md:text-figma-titles-md-size lg:text-figma-titles-xl-size lg:leading-[1.1]",
        className,
      )}
      {...props}
    />
  );
}
